module.exports = __webpack_public_path__ + "static/media/Promo_Card_3.bbd56a5b.png";